<div class="container">
    <p class="no-order-found-text">{{ "orderItemList.noOrder" | translate }}</p>
    <app-button variant="hero" buttonClass="shadow-btn" (onClick)="backToOrders()">
        {{ "orderItemList.button.back" | translate }}
    </app-button>
</div>
